<!--
   Created by qing on 2019/12/28 7:03 下午
   Des: 轨迹地图视图
-->
<template>
  <div class="path-map-view-page">

    <div class="map-header">
      <div class="top">
        <div class="des">
          共 <span>{{realDataList.length}}</span> 条轨迹
        </div>
      </div>
      <div class="bottom">
        <div v-if="viewSet.openPlanLine === 'YES'">
          计划路线
          <van-switch v-model="planPath" size="14px" active-value="YES" inactive-value="NO" @change="planPathChange"/>
        </div>
        <div>
          实际路线
          <van-switch v-model="realPath" size="14px" active-value="YES" inactive-value="NO" @change="realPathChange"/>
        </div>
        <div class="handle-container">
          <van-icon name="play-circle-o" @click="resumeAnimation"></van-icon>
          <van-icon name="pause-circle-o" @click="pauseAnimation"></van-icon>
          <van-icon v-if="false" name="replay" @click="restartAnimation"></van-icon>
        </div>
      </div>
    </div>

    <div class="map__container-wrapper">
      <el-amap vid="amap" ref="amap" class="amap-demo">
      </el-amap>
    </div>
    <van-popup
      class="list-card-popup"
      v-model="show"
      position="bottom"
      :overlay="overlay"
      get-container="body"
      close-on-popstate
      :close-on-click-overlay="false"
      @click-overlay="onClickOverlay"
      :style="{ height: popupHeight }">
      <div
        class="popup-title"
        @click="onClickTitle">
        数据列表
        <span style="color: #05A971; margin-left: 10px">(共{{showDataList.length}}条数据)</span>
      </div>
      <div class="list-card-container">
        <div class="select-group" @click="onClickSelectGroup">
          已选择{{selectGroups.length}}条轨迹，点击可切换轨迹
        </div>
        <template v-if="showDataList.length">
        <div class="list-card" v-for="item in showDataList" :key="item.instanceId">
          <div class="list-card-wrapper" @click="onClickCard(item)">
            <div class="card-info" :style="{width: viewSet.cardConfigInfo.showImage && item.image.showData ? 'calc(100% - 100px)' : '100%'}">
              <div class="title">
                <div
                  class="color"
                  v-if="viewSet.cardConfigInfo.showColor"
                  :style="{backgroundColor : item.color ? item.color.showData : ''}"
                ></div>
                <h3
                  v-if="viewSet.cardConfigInfo.showTitle">
                  {{item.title.showData}}
                </h3>
              </div>
              <p v-if="viewSet.cardConfigInfo.showTime">
                {{actionFormatDate(item.time.showData, item.time.formatStr) || ''}}
              </p>
              <div class="card-info-row">

                <div
                  class="row-item"
                  v-for="showData in item.content"
                  :key="showData.fieldId">
                  <h5>
                    {{showData.fieldTitle}}：
                  </h5>
                  <div class="item-content">
                    <FieldShowData
                      :show-data="showData"
                      :memberShowType="viewSet.cardConfigInfo.memberShowType">
                    </FieldShowData>
                  </div>
                </div>
              </div>
            </div>
            <div class="img-container" v-if="viewSet.cardConfigInfo.showImage && item.image.showData">
              <img :src="item.image.showData" alt="">
            </div>
          </div>
        </div>
        </template>
        <div v-else class="empty-data-container">
          <div>暂无数据</div>
        </div>
      </div>
    </van-popup>

    <van-popup
      class="select-group-popup"
      v-model="selectVisible"
      :style="{ width: '80%' }"
      get-container="body"
      :close-on-click-overlay="false"
      position="right">
      <div class="header">
        <div class="clear" @click="clearSelectGroup">清空</div>
        <div class="all" @click="selectAllGroup">全选</div>
      </div>
      <div class="group-container">
        <van-checkbox-group v-model="selectGroups">
          <van-checkbox
            v-for="item in realDataList"
            :key="item.key"
            :name="item.key">
            {{item.groupName}}
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="footer">
        <van-button type="default" @click="selectGroupCancel">取消</van-button>
        <van-button type="primary" @click="selectGroupConfirm">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import FormSet from "../RyForm"
  import ViewSet from "../RyView"
  import {
    FORM_TYPE__FILL,
    FORM_ITEM__SINGLE_LINE,
    DATE_TYPE__DAY,
    DATE_TYPE__MONTH,
    DATE_TYPE__MINUTE,
    DATE_TYPE__SECTION,
    DATE_TYPE__YEAR
  } from "../RyForm/types"
  import {SUCCESS} from "../store/types"
  import {clone, formatDate, arrCompare} from "../../assets/js/Untis"
  import FieldShowData from "./FieldShowData"
  import {
    FORM_VIEW_TYPE_WRITE_FORM,
    FORM_VIEW_TYPE_DATA_HANDLE,
    FORM_VIEW_TYPE_DATA_VIEW,
    FORM_VIEW_TYPE_BOARD_VIEW, FORM_VIEW_TYPE_MAP_PATH_VIEW
  } from "../../assets/types/index"
  import {uuid} from "../RyForm/utils";

  export default {
    props: {
      formId: {
        type: String,
        default: ''
      },
      viewId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        FORM_VIEW_TYPE_DATA_VIEW,
        FORM_VIEW_TYPE_BOARD_VIEW,
        FORM_VIEW_TYPE_MAP_PATH_VIEW,
        show: true,
        popupHeight: '40px',
        overlay: false,
        selectVisible: false,
        loading: true,
        viewSet: ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.formId,
          viewId: this.viewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.$store.getters.currentAppId
        }),
        formSet: FormSet.init({
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.$store.getters.currentAppId
        }),
        relateViewSet: null,
        filter: {},

        plugin: [{
          pName: 'Geolocation',
          events: {
            click: (o) => {
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {

                }
              });
            }
          },
          buttonPosition: 'LT'
        }],
        center: [108.947325, 34.317759],
        marker: null,
        radio: 'data',
        originalData: {},
        markerMap: {},
        linePathsMap: [],
        showDataList: [],
        markerObjectMap: {},
        groupDataList: [],
        realDataList: [],
        selectGroups: [],
        oldSelectGroups: [],

        planMarkerMap: {}, // 计划路线存地图上的线对象
        planMarkerObjectMap: {}, // 计划路线存地图上的点对象
        realPath: 'YES',
        planPath: 'YES',
      };
    },
    components: {
      FieldShowData
    },
    created() {
      this.fetchDataViewData()
    },
    computed: {
      isAdmin() {
        const adminInfo = this.$store.getters.adminInfo
        return adminInfo && (adminInfo.creator || adminInfo.topAdmin)
      },
      fieldList() {
        let fields = this.formSet.filterField({
          invertType: [
            FormSet.TYPES.FORM_ITEM__SECTION,
            FormSet.TYPES.FORM_ITEM__RTF,
            FormSet.TYPES.FORM_ITEM__TABLE,
            FormSet.TYPES.FORM_ITEM__SUMMARY,
            FormSet.TYPES.FORM_ITEM__DESCRIPTION,
            FormSet.TYPES.FORM_ITEM__BUTTON
          ]
        }).filter(field => field.parent.type !== FormSet.TYPES.FORM_ITEM__TABLE)
        return fields
      },
    },
    methods: {

      fetchRelateView() {

        this.relateViewSet = ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.viewSet.realLineConfig.dataFormId,
          viewId: this.viewSet.realLineConfig.detailViewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.viewSet.realLineConfig.dataAppId
        })
        if (this.viewSet.realLineConfig.detailViewId === FORM_VIEW_TYPE_DATA_HANDLE) {
          // 选的是管理数据

        } else {
          // 数据视图
          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.relateViewSet.setConf(resultObject)
          }).catch(console.error)
            .finally(() => {
              this.loading = false
            })
        }
      },

      /**********************  数据视图操作 *************************/
      fetchDataViewData() {

        this.formSet = FormSet.init({
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.$store.getters.currentAppId
        })
        this.viewSet = ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.formId,
          viewId: this.viewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.$store.getters.currentAppId
        })

        Promise.all([
          // 还原formSet结构
          this.$store.dispatch('actionMergeStructure', {
            formId: this.formId,
            formType: FORM_TYPE__FILL,
            viewType: 1,
            viewId: this.viewId,
          }).then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.formSet.setStructure(resultObject.structureInfo)
              this.formSet.setPermission(resultObject.permissionInfo.permissionList)
              this.formSet.setConf(resultObject.detailInfo)
              this.formSet.setWidth(resultObject.widthInfo)
            }
          }),
          // 还原viewSet结构
          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.viewSet.setConf(resultObject)
          }),
        ]).then(() => {
          this.fetchData()
          this.fetchRelateView()
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },

      async fetchData() {
        const res = await this.$store.dispatch('actionFormViewMapPathData', {
          appId: this.viewSet.appId,
          formId: this.formId,
          viewId: this.viewId
        }).catch(console.error)

        this.originalData = res
        res.realDataList.forEach(item => {
          console.log('clone- item', clone(item))
          // const arr = []
          // item.dataList.forEach(d => {
          //   arr.push([d.latitude, d.longitude])
          // })
          this.$set(this.linePathsMap, item.key, item.dataList)
          this.selectGroups.push(item.key)
          this.oldSelectGroups.push(item.key)
          this.realDataList.push(clone(item))
        })
        res.groupDataList.forEach(item => {
          this.$set(this.linePathsMap, item.key, item.dataList)
          this.groupDataList.push(clone(item))
        })

        this.handlePlanPathLine()
        this.handlePathLine()
        this.handleDataList(res.headerList, res.dataList)
      },

      // 处理计划轨迹数据
      handlePlanPathLine() {
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }

        const icon = new AMap.Icon({
          size: new AMap.Size(24, 40),    // 图标尺寸
          image: 'https://api.pro.surongyun.cn/fs/file/download/516371809210204161',
          imageSize: new AMap.Size(24, 40)   // 根据所设置的大小拉伸或压缩图片
        });

        this.groupDataList.forEach(item => {
          const lineArr = this.linePathsMap[item.key]
          const path = []

          const markerObjectArr = []
          lineArr.forEach((line, idx) => {
            if (idx === 0) {
              // 将 Icon 实例添加到 marker 上:
              const marker = new AMap.Marker({
                position: [line.longitude, line.latitude],
                offset: new AMap.Pixel(-10, -10),
                icon: icon, // 添加 Icon 实例
                zoom: 13
              })
              map.add(marker)
              markerObjectArr.push(marker)
            }

            if (idx === lineArr.length - 1) {
              // 将 Icon 实例添加到 marker 上:
              const marker = new AMap.Marker({
                position: [line.longitude, line.latitude],
                offset: new AMap.Pixel(-10, -10),
                icon: icon, // 添加 Icon 实例
                zoom: 13
              })
              map.add(marker)
              markerObjectArr.push(marker)
            }
            path.push(new AMap.LngLat(line.longitude, line.latitude))
          })
          const polyline = new AMap.Polyline({
            path: path,
            isOutline: true,
            borderWeight: 3, // 线条宽度，默认为 1
            strokeColor: '#959699', // 线条颜色
            outlineColor: '#ffeeff',
            strokeOpacity: 1,
            strokeWeight: 5,
            lineJoin: 'round', // 折线拐点连接处样式',
            lineCap: 'round',
          });
          map.add(polyline);

          this.$set(this.planMarkerMap, item.key, polyline)
          this.$set(this.planMarkerObjectMap, item.key, markerObjectArr)
        })

        map.setFitView();
      },

      // 处理实际轨迹数据
      handlePathLine() {

        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }
        console.log('map', map)

        this.selectGroups.forEach(key => {

          const lineArr = this.linePathsMap[key]
          const group = this.realDataList.filter(item => item.key === key)[0]

          // 添加点位
          this.addMarkerToMap(key, lineArr)
          // 添加轨迹
          this.addPolylineToMap(key, lineArr, group)
        })

        map.setFitView();
      },

      // 处理展示数据
      handleDataList(headerList, dataList) {

        let showDataList = []
        dataList.forEach(item => {
          let showData = {
            key: uuid(),
            title: {},
            charge: {},
            time: {},
            image: {},
            content: [],
            applyTime: item['applyTime'],
            instanceId: item['instanceId'],
            stepId: item['stepId'],
            updateTime: item['updateTime'],
            userId: item['userId']
          }
          // 卡片title
          if (this.viewSet.cardConfigInfo.showTitle === 1) {
            showData.title = {
              showData: item[this.viewSet.cardConfigInfo.titleFieldId],
              fieldId: this.viewSet.cardConfigInfo.titleFieldId,
              type: 'title'
            }
          }
          // 卡片颜色
          if (this.viewSet.cardConfigInfo.showColor === 1) {
            // 获取当前选择的选项的id
            const optId = item[this.viewSet.cardConfigInfo.colorField]
            const field = this.formSet.fields[this.viewSet.cardConfigInfo.colorFieldId]
            let opt = null
            if (field) {
              opt = field.options.filter(opt => opt.id === optId)[0]
            }
            showData.color = {
              showData: opt ? opt.color : '',
              fieldId: this.viewSet.cardConfigInfo.colorField,
              type: 'color'
            }
          }
          // 截止时间
          if (this.viewSet.cardConfigInfo.showTime === 1) {
            const field = this.formSet.fields[this.viewSet.cardConfigInfo.timeFieldId]
            let formatStr = 'yyyy-MM-dd HH:mm'
            if (field) {
              formatStr = field.formatStr
            }

            showData.time = {
              showData: item[this.viewSet.cardConfigInfo.timeFieldId],
              fieldId: this.viewSet.cardConfigInfo.timeFieldId,
              formatStr, // 0 精确到天, 1精确到秒
              type: 'deadline'
            }
          }
          // 图片
          if (this.viewSet.cardConfigInfo.showImage) {
            if (this.viewSet.cardConfigInfo.imageFieldId.includes('IMAGE_')) {
              const imgArr = item[this.viewSet.cardConfigInfo.imageFieldId]
              showData.image = {
                showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                fieldId: this.viewSet.cardConfigInfo.imageFieldId,
                type: 'title'
              }
            } else {
              showData.image = {
                showData: item[this.viewSet.cardConfigInfo.imageFieldId],
                fieldId: this.viewSet.cardConfigInfo.imageFieldId,
                type: 'title'
              }
            }

          }
          // 卡片内容
          this.viewSet.cardConfigInfo.showFieldList.forEach(fieldId => {
            let field = this.formSet.fields[fieldId]
            if (field) {
              showData.content.push({
                showData: item[fieldId],
                type: field.type,
                ...field
              })
            }
          })
          showDataList.push(showData)
        })
        this.showDataList = showDataList
      },

      // 分组选择变化时
      selectGroupsChange() {
        const result = arrCompare(this.oldSelectGroups, this.selectGroups)
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }

        if (result.add.length) {

          result.add.forEach(key => {

            const lineArr = this.linePathsMap[key]
            const group = this.realDataList.filter(item => item.key === key)[0]

            // 添加点位
            this.addMarkerToMap(key, lineArr)
            // 添加轨迹
            this.addPolylineToMap(key, lineArr, group)
          })
        } else if (result.del.length) {

          result.del.forEach(key => {
            const o = this.markerMap[key]
            map.remove(o.marker)
            map.remove(o.polyline)
            map.remove(o.passedPolyline)
            delete this.markerMap[key]

            const markers = this.markerObjectMap[key]
            map.remove(markers)
            delete this.markerObjectMap[key]
          })
        }

        this.oldSelectGroups.splice(0, this.oldSelectGroups.length, ...this.selectGroups)
      },

      // 给地图上添加轨迹
      addPolylineToMap(key, lineArr, group) {
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }
        const arr = []
        lineArr.forEach(d => {
          arr.push([d.longitude, d.latitude])
        })

        let icon = null
        if (this.viewSet.realLineConfig.showImageFieldId === 'https://webapi.amap.com/images/car.png') {
          icon = new AMap.Icon({
            size: new AMap.Size(46, 26),    // 图标尺寸
            // image: group.showImage,  // Icon的图像
            image: this.viewSet.realLineConfig.showImageFieldId,  // Icon的图像
            imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(46, 26)   // 根据所设置的大小拉伸或压缩图片
          })
        } else {
          icon = new AMap.Icon({
            size: new AMap.Size(66, 36),    // 图标尺寸
            // image: group.showImage,  // Icon的图像
            image: this.viewSet.realLineConfig.showImageFieldId,  // Icon的图像
            imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(66, 36)   // 根据所设置的大小拉伸或压缩图片
          })
        }
        const marker = new AMap.Marker({
          map,
          position: arr[0],
          icon: icon,
          offset: new AMap.Pixel(-26, -13),
          autoRotation: true,
          angle: -90,
        });
        const polyline = new AMap.Polyline({
          map: map,
          path: arr,
          showDir: true,
          strokeColor: "#28F",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });
        const passedPolyline = new AMap.Polyline({
          map: map,
          // path: lineArr,
          strokeColor: "#AF5",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });

        marker.on('moving', function (e) {
          passedPolyline.setPath(e.passedPath)
        });

        marker.moveAlong(arr, this.viewSet.animationSpeed || 500)

        this.$set(this.markerMap, key, {
          marker,
          polyline,
          passedPolyline
        })
      },
      // 给地图上添加点位
      addMarkerToMap(key, markerArr) {
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }

        const markerObjectArr = []

        const icon = new AMap.Icon({
          size: new AMap.Size(40, 50),    // 图标尺寸
          image: '//webapi.amap.com/theme/v1.3/images/newpc/way_btn2.png',  // Icon的图像
          imageOffset: new AMap.Pixel(0, -60),  // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(40, 50)   // 根据所设置的大小拉伸或压缩图片
        });
        markerArr.forEach(item => {

          // 将 Icon 实例添加到 marker 上:
          const marker = new AMap.Marker({
            position: [item.longitude, item.latitude],
            offset: new AMap.Pixel(-10, -10),
            // icon: icon, // 添加 Icon 实例
            zoom: 13
          })

          marker.instanceId = item.instanceId
          marker.on('click', e => {
            console.log('click', e)

            if (this.viewSet.viewDetail === 'NO') {
              return
            }
            let index = 0
            for (let i = 0; i < this.originalData.dataList.length; i++) {
              if (this.originalData.dataList[i].instanceId === item.instanceId) {
                index = i
                break
              }
            }
            this.$emit('onClickData', {
              instanceId: e.target.instanceId,
              viewId: this.viewSet.realLineConfig.detailViewId,
              dataList: this.originalData.dataList,
              index
            })

          });
          markerObjectArr.push(marker)
        })

        this.$set(this.markerObjectMap, key, markerObjectArr)
        map.add(markerObjectArr)
      },


      pauseAnimation() {
        Object.values(this.markerMap).forEach(o => {
          o.marker.pauseMove();
        })
      },

      resumeAnimation() {
        Object.values(this.markerMap).forEach(o => {
          o.marker.resumeMove();
        })
      },

      restartAnimation() {

      },

      stopAnimation() {
        Object.values(this.markerMap).forEach(o => {
          o.marker.stopMove();
        })
      },

      filterFormData(filter) {
        // this.dataViewOpts.filter = filter

      },

      foldFilter() {

      },

      openFilterPanel() {
        if (this.$refs.filterPanel) {
          this.$refs.filterPanel.open()
        }
      },

      radioChange() {
        // if (this.radio === 'filter') {
        //   this.openFilterPanel()
        // }
      },

      // 选择轨迹
      onClickSelectGroup() {
        this.selectVisible = true
      },

      actionFormatDate(d, formatter) {
        return formatDate(d)(formatter)
      },
      //  根据fieldId获取控件
      fetchFieldWithFieldId(fieldId) {
        return this.fieldList.filter(field => field.dataId === fieldId)[0] || {}
      },


      // 数据视图点击自定义按钮，执行事件后关闭弹窗，刷新数据
      updateData() {
        setTimeout(() => {
          this.refreshData()
        }, 800)
      },

      // 刷新数据视图
      refreshData() {

      },
      // 删除卡片
      deleteView() {
        // 删除成功后，关闭详情弹窗
        if (this.$refs.formViewDataDetail) this.$refs.formViewDataDetail.close()
        this.refreshData()
      },
      // 修改卡片数据
      saveFormData() {
        this.refreshData()
      },

      onClickCard(item) {

        if (this.viewSet.viewDetail === 'NO') {
          return
        }
        let index = 0
        for (let i = 0; i < this.originalData.dataList.length; i++) {
          if (this.originalData.dataList[i].instanceId === item.instanceId) {
            index = i
            break
          }
        }
        this.$emit('onClickData', {
          instanceId: item.instanceId,
          viewId: this.viewSet.realLineConfig.detailViewId,
          dataList: this.originalData.dataList,
          index
        })
      },

      onClickTitle() {
        this.popupHeight = '80%'
        this.overlay = true
      },
      onClickOverlay () {
        this.popupHeight = '40px'
        this.overlay = false
      },

      clearSelectGroup() {
        this.selectGroups.splice(0, this.selectGroups.length)
      },
      selectAllGroup() {
        this.selectGroups.splice(0, this.selectGroups.length, ...this.realDataList.map(item => item.key))
      },

      selectGroupCancel() {
        this.selectGroups.splice(0, this.selectGroups.length, ...this.oldSelectGroups)
        this.selectVisible = false
      },
      selectGroupConfirm() {
        this.selectGroupsChange()
        this.selectVisible = false
      },

      planPathChange() {
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }
        if (this.planPath === 'YES') {
          this.handlePlanPathLine()
        } else {
          Object.keys(this.planMarkerMap).forEach(key => {
            const polyline = this.planMarkerMap[key]
            map.remove(polyline)
            delete this.planMarkerMap[key]

            const markers = this.planMarkerObjectMap[key]
            map.remove(markers)
            delete this.planMarkerObjectMap[key]
          })
        }
      },

      realPathChange() {
        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        if (!map) {
          return
        }
        if (this.realPath === 'YES') {
          this.selectGroups.forEach(key => {

            const lineArr = this.linePathsMap[key]
            const group = this.realDataList.filter(item => item.key === key)[0]

            console.log('lineArr', lineArr)
            // 添加点位
            this.addMarkerToMap(key, lineArr)
            // 添加轨迹
            this.addPolylineToMap(key, lineArr, group)
          })
        } else {
          Object.keys(this.markerMap).forEach(key => {
            const o = this.markerMap[key]
            map.remove(o.marker)
            map.remove(o.polyline)
            map.remove(o.passedPolyline)
            delete this.markerMap[key]

            const markers = this.markerObjectMap[key]
            map.remove(markers)
            delete this.markerObjectMap[key]
          })
        }
      },
    },
    watch: {}
  };
</script>

<style lang="less">

  .path-map-view-page {
    width: 100%;
    height: 100%;
    position: relative;

    .map-header {
      height: 60px;
      background-color: #ffffff;
      /*border-top: 4px solid #F6F6F6;*/
      padding: 10px 20px;
      border-bottom: 1px solid #e6e6e6;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .des {
          color: #9f9f9f;
          font-size: 13px;
        }

        .van-icon {
          font-size: 20px;
          margin-left: 10px;
        }
      }

      .bottom {
        display: flex;
        align-items: center;
        margin-top: 10px;

        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 10px;
          font-size: 14px;

          .van-switch {
            margin-left: 10px;
          }
        }

        .handle-container {
          margin-right: 0;
          margin-top: -5px;
        }

        .van-icon {
          font-size: 20px;
          margin-left: 10px;
        }
      }
    }
    .map__container-wrapper {
      position: relative;
      width: 100%;
      height: calc(100% - 40px);
    }

    .handle-panel {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 400px;
      background-color: #fff;
      padding: 10px;
      z-index: 2;

      .path-handle-container {

        .path-title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 10px;
        }

        .handle-container {
          display: flex;
          margin-bottom: 10px;
        }

        .total {
          font-size: 14px;

          > span {
            color: #2d8cf0;
          }
        }
      }

      .filter-item-container {
        height: calc(100% - 200px);
        width: 100%;

        > .filter-panel-container {
          height: 100%;
        }
      }
    }
  }

  .empty-page {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    background-color: #fff;
  }

  .list-card-popup {

    .popup-title {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
    }

    .list-card-container {
      height: calc(100% - 40px);
      width: 100%;
      overflow: auto;

      .select-group {
        color: #4A66FA;
        font-size: 13px;
        margin-left: 20px;
      }

      .list-card {
        position: relative;
        width: 360px;
        margin: 0 auto;
        background-color: #fff;
        display: flex;
        overflow: hidden;
        color: #303133;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 10px;

        .color {
          width: 5px;
          background-color: #4A66FA;
        }

        .list-card-wrapper {
          cursor: pointer;
          display: flex;
          flex: 1 1;
          width: calc(100% - 5px);

          .card-info {
            padding: 10px 10px 0 10px;
            width: calc(100% - 100px);

            .title {
              display: flex;
              align-items: center;

              .color {
                width: 5px;
                height: 16px;
                background-color: #4A66FA;
                margin-right: 5px;
              }

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            p {
              font-size: 13px;
              color: #959699;
              margin: 0;
            }

            .card-info-row {
              width: 100%;
              display: flex;
              flex-direction: column;

              .row-item {
                width: 100%;
                flex: 1 1;
                display: flex;
                align-items: center;
                margin-bottom: 6px;

                h5 {
                  font-size: 11px;
                  color: #979797;
                  line-height: 16px;
                  max-width: 100px;
                  min-width: 40px;
                  margin: 0;
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .item-content {
                  flex: 1;
                  height: auto !important;
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  color: #262626;

                  > div {
                    width: 100%;
                    padding-left: 0;
                    padding-right: 0;
                    margin-right: 8px;
                    line-height: 18px;
                    height: auto;
                    color: #5e6d82;
                  }
                  .field-show-data-container > div {
                    line-height: 18px;
                  }

                  .field-show-data-content {
                    display: block;
                    line-height: 18px;
                    white-space: normal;
                  }
                }
              }
            }
          }

          .img-container {
            border-radius: 1px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 90px;
              height: 90px;
              object-fit: cover;
            }
          }
        }

      }

      .empty-data-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #5e6d82;

        i {
          font-size: 30px;
          margin-bottom: 20px;
        }
      }
    }
  }

  .select-group-popup {
    height: 100%;

    .header {
      width: 100%;
      height: 30px;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;


      .clear {
        color: #4A66FA;
        font-size: 14px;
        margin-right: 20px;
      }

      .all {
        color: #05A971;
        font-size: 14px;
      }
    }

    .group-container {

      height: calc(100% - 70px);
      overflow: auto;
      padding: 10px;

      .van-checkbox {
        margin-bottom: 10px;
      }
    }

    .footer {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .van-button {
        margin-right: 20px;
        height: 30px;
      }
    }
  }
</style>